<template>
  <div class="nuttrema-list-item-custom" v-if="group.length > 0">
    <div class="nuttrema-list-item__group">
      <span>{{ $t(`label.${title}`) }}</span>
    </div>

    <div class="nuttrema-list-item__table">
      <nuttrema-table>
        <template slot="header">
          <nuttrema-table-column :style-props="columns.iconica.style" theme="header"></nuttrema-table-column>
          <nuttrema-table-column :style-props="columns.name.style" :label="columns.name.label" theme="header" ></nuttrema-table-column>
          <nuttrema-table-column :style-props="columns.duration.style" :label="columns.duration.label" theme="header"></nuttrema-table-column>
          <nuttrema-table-column :style-props="columns.nutrition.style" :label="columns.nutrition.label" theme="header"></nuttrema-table-column>
          <nuttrema-table-column :style-props="columns.status.style" :label="columns.status.label" theme="header"></nuttrema-table-column>
          <nuttrema-table-column :style-props="columns.operations.style" theme="header"></nuttrema-table-column>
        </template>

        <template slot="body">
          <div class="nuttrema-table__body__row" v-for="item in group" :id="`nuttrema-table-row-${item.id}`">

            <nuttrema-table-column :style-props="columns.iconica.style">
              <nuttrema-iconica-kcal
                :text="item.name"
                :image="getImagePath(item)"
                :title="$t('label.average_daily_energy_value')"
                :nutrientDefinition="_get(item, 'NutritionInfo', {})">
              </nuttrema-iconica-kcal>
            </nuttrema-table-column>

            <nuttrema-table-column :style-props="columns.name.style">
              <div class="two-line-text is-link" @click="gotoDetailsPage(item.id)" :title="$t('label.view_detail')">
                <div class="two-line-text__title">
                  <span>{{ item.name }}</span>
                </div>
                <div class="two-line-text__description" v-if="item.description">
                  <span>{{ item.description }}</span>
                </div>
                <div class="two-line-text__origin">
                  <span>{{ _get(item, 'ProgramType.name') }}, {{ item.created_at | moment('ll') }}</span>
                </div>
              </div>
            </nuttrema-table-column>

            <nuttrema-table-column :label="columns.duration.label" :style-props="columns.duration.style">
              <div class="two-line-text">
                <div class="two-line-text__description">
                  <span v-if="item.start_date && item.end_date">{{ item.start_date | moment('l') }} - {{ item.end_date | moment('l') }}</span>
                  <span>{{ $tc('label.days_number', item.duration, { duration: item.duration }) }}</span>
                </div>
              </div>
            </nuttrema-table-column>

            <nuttrema-table-column :label="columns.nutrition.label" :style-props="columns.nutrition.style">
              <nuttrema-nutritions-stucture-bars :nutritions="_get(item, 'NutritionInfo', {})"></nuttrema-nutritions-stucture-bars>
            </nuttrema-table-column>

            <nuttrema-table-column :style-props="columns.status.style">
              <nuttrema-status-tag
                 related="program_assigned"
                :status="item.status"
                :available="['draft', 'active', 'current', 'inactive', 'on_hold', 'canceled', 'archived']">
              </nuttrema-status-tag>
            </nuttrema-table-column>

            <nuttrema-table-column :style-props="columns.operations.style">
              <router-link
                class="el-button el-button--text"
                :to="{ name: _get(meta, 'navigation.edit'), params: { id: item.id }, query: { returnTo }}">
                {{ $t('label.view_detail') }} <i class="el-icon-arrow-right el-icon-right"></i>
              </router-link>
            </nuttrema-table-column>

          </div>
        </template>
      </nuttrema-table>
    </div>
    <!-- end ~ nuttrema-list-item__table -->

  </div>
  <!-- end ~ nuttrema-list-item-custom -->
</template>

<script>
import { get } from 'lodash';
import NuttremaIndexListItem from 'components/ui/list/nuttrema-index-list-item';

import NuttremaStatusTag from 'components/ui/label/nuttrema-status-tag';
import NuttremaIconicaKcal from 'components/ui/label/nuttrema-iconica-kcal';
import NuttremaNutritionsStuctureBars from 'components/ui/label/nuttrema-nutritions-stucture-bars';

export default {
  name: 'cmpt-assigned-programs-list-item',
  mixins: [NuttremaIndexListItem],
  components: {
    NuttremaStatusTag,
    NuttremaIconicaKcal,
    NuttremaNutritionsStuctureBars,
  },
  data() {
    return {
      columns: {
        iconica: {
          label: null,
          style: {
            width: '50px',
            'justify-content': 'center',
          },
        },
        name: {
          label: 'label.name',
          style: {
            'min-width': '200px',
            'flex-basis': 'auto',
            'flex-grow': '1',
          },
        },
        duration: {
          label: 'label.duration',
          style: {
            'max-width': '175px',
            'min-width': '100px',
            'flex-basis': 'auto',
            'flex-grow': '1',
          },
        },
        nutrition: {
          label: 'label.nutrition_information',
          style: {
            'max-width': '210px',
            'min-width': '210px',
            'flex-basis': 'auto',
            'flex-grow': '1',
          },
        },
        status: {
          label: 'label.status',
          style: {
            'max-width': '100px',
            'min-width': '50px',
            'flex-basis': 'auto',
            'flex-grow': '1',
          },
        },
        operations: {
          label: null,
          style: {
            'min-width': '100px',
            'justify-content': 'flex-end',
          },
        },
      },
    };
  },
  methods: {
    getImagePath(item) {
      const path = get(item, 'CoverImage.path', '');
      const filename = get(item, 'CoverImage.thumbnails.medium.filename', '');
      return `${process.env.IMAGES_ROOT}${path}${filename}`;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/participants/assigned-programs/cmpt-assigned-programs-list-item.vue